import {Alert, Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {getAgentServices} from "../../services/service/service";
import {AgentServiceGrid} from "./agent_service_grid";
import {AgentServiceCheckForm} from "./agent_service_check";
import {AgentServiceDocumentationForm} from "./agent_service_documentation_form";
import {AgentServiceActionForm} from "./agent_service_action_form";
import {ServiceContext} from "./service_context";
import {ServiceActivities} from "./service_activity";
import {CardFooterPaginator} from "../system/cardFooterPaginator";
import {BsInfoCircle} from "react-icons/bs";


export function AgentServiceManagement() {

  const [step, setStep] = useState(null);

  const [agentServices, setAgentServices] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(5);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [documentGridSelectedRow, setDocumentGridGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);
  const [allAccepted, setAllAccepted] = useState(false);

  const [branchInfo, setBranchInfo] = useState(null)

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getAgentServices(paginate);
    if (result.status === 200) {
      const {agentServiceList, total_count} = result.data;
      setAgentServices(agentServiceList || []);
      setGridTotalRowCount(total_count);
    }
  }

  useEffect(() => {
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(paginate)
  }, [lastDataRefresh, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <ServiceContext.Provider value={{
      modalOpen,
      setModalOpen,
      gridRowCount,
      setGridRowCount,
      gridCurrentPage,
      setGridCurrentPage,
      service: gridSelectedRow,
      setService: setGridSelectedRow,
      document: documentGridSelectedRow,
      setDocument: setDocumentGridGridSelectedRow,
      lastDataRefresh,
      setLastDataRefresh,
      step,
      setStep,
      allAccepted,
      setAllAccepted,
      from: "agent",
      branchInfo,
      setBranchInfo
    }}>
      <div className="">
        {step === "check" &&
          <AgentServiceCheckForm/>
        }

        {step === "documentation" &&
          <AgentServiceDocumentationForm/>
        }

        {step === "action" &&
          <AgentServiceActionForm/>
        }
        {step === "report" &&
          <ServiceActivities/>
        }

        <Card className="pt-8">
          <CardHeader floated={true} shadow={false} className="flex flex-row rounded-none justify-between">
            <div className="mb-8 flex items-center justify-between">
              <Typography variant="h5" color="blue-gray">خدمات من</Typography>
            </div>
            <Button className="flex items-center gap-x-2 py-0 h-12" size="small" variant="outlined" onClick={() => {
              setStep("guide")
              setModalOpen(true)
            }}>
              <BsInfoCircle className="h-5 w-5"/>
              <Typography className="font-light">
                راهنما
              </Typography>
            </Button>
          </CardHeader>

          <CardBody className="overflow-x-auto w-full">
            <Alert className="w-full px-0" variant="gradient">
              <Typography variant="h5" className="mb-4">
                مشاور گرامی؛
              </Typography>
              <Typography variant="body" color="">
                <li>
                  از طریق دکمه مشاهده/بررسی مدارک می توانید با کاربر ارتباط(تماس تلفنی و نقل و انتقال
                  مدارک و مستندات) بگیرید.
                </li>
              </Typography>
              <Typography variant="body" color="">
                <li>
                  طبق قوانین پلتفرم مباشر، پس از پرداخت، بایستی مرحله به مرحله از طریق دکمه گزارش
                  پیشرفت مراحل خدمت را به کاربر اطلاع رسانی نمائید.
                </li>
              </Typography>
              <Typography variant="body" color="">
                <li>
                  بدیهی است در صورت عدم تامین مدارک و مستندات لازم از سوی کاربر، هرگونه تاخیر و
                  تبعات بر عهده کاربر خواهد بود.
                </li>
              </Typography>
            </Alert>

            <AgentServiceGrid
              AgentServices={agentServices}
              setSortBy={setSortBy}
              sortType={sortType}
              setSortType={setSortType}
            />
          </CardBody>

          <CardFooterPaginator
            active={gridCurrentPage}
            setActive={setGridCurrentPage}
            totalRows={gridTotalRowCount}
            rowsCount={gridRowCount}
            setRowsCount={setGridRowCount}
            from={from}
            to={to}
          />

        </Card>
      </div>
    </ServiceContext.Provider>
  );
}